import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconBolt.tsx
const OutlinedFilledBolt = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m298-52 40-280H123l399-577h113l-40 320h260L409-52H298Z" })
});
const OutlinedBolt = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m404-181 265-321H497l33-264-241 347h149l-34 238ZM298-52l40-280H123l399-577h113l-40 320h260L409-52H298Zm182-422Z" })
});
const RoundedFilledBolt = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M338-332H213q-29 0-42.5-25t3.5-49l376-542q10-14 25-18.5t30 1.5q15 5 24 19.5t7 30.5l-41 326h159q30 0 42.5 27t-5.5 50L381-18Q371-5 355.5-1.5T325-5q-14-6-21.5-19.5T298-55l40-277Z" })
});
const RoundedBolt = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m404-181 265-321H497l33-264-241 347h149l-34 238Zm-66-151H213q-28.87 0-42.44-25Q157-382 174-406l376-542q10-14 25-18.5t30 1.5q15 5 24 19.67 9 14.67 7 30.33l-41 326h159q30.36 0 42.68 27T791-512L381-18Q370.56-5.1 355.28-1.55 340 2 325-5.25q-14-6.25-21.5-19.63Q296-38.25 298-55l40-277Zm140-140Z" })
});
const SharpFilledBolt = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m298-52 40-280H123l399-577h113l-40 320h260L409-52H298Z" })
});
const SharpBolt = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m404-181 265-321H497l33-264-241 347h149l-34 238ZM298-52l40-280H123l399-577h113l-40 320h260L409-52H298Zm182-422Z" })
});
const componentMap = {
	outlined: OutlinedBolt,
	"outlined-fill": OutlinedFilledBolt,
	rounded: RoundedBolt,
	"rounded-fill": RoundedFilledBolt,
	sharp: SharpBolt,
	"sharp-fill": SharpFilledBolt
};
const IconBolt = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconBolt };